export type Permission = string;
export type Restriction = string;

export enum PermissionType {
  PERMISSION,
  RESTRICTION,
  ROLE,
}
